import { DataDogLogger } from 'utils/dataDog';
import { MILLISECONDS_PER_SECOND } from 'constants/date';
import { PollUntilConditionArgs } from './types';
/**
 * Polling function to determine when a condition has turned truthy
 * @param conditionFn a callback function that should resolve to a boolean.
 * @param description string to be included with error log in case of failure
 * @param ms milliseconds of polling interval
 * @param max milliseconds of polling allowed before error is triggered
 */
export const pollUntilConditionMet = async ({
  conditionFn,
  description,
  ms = 250,
  max = 30 * MILLISECONDS_PER_SECOND,
}: PollUntilConditionArgs) => {
  let elapsed = 0;
  const poll = (resolve: (value: null) => void, reject: (reason: null) => void) => {
    if (conditionFn()) {
      resolve(null);
    } else {
      elapsed += ms;
      if (elapsed >= max) {
        DataDogLogger.error(
          new Error('Polling condition not met after significant amount of time.'),
          { description, interval: ms, elapsed: max },
        );
        reject(null);
      } else {
        setTimeout(() => poll(resolve, reject), ms);
      }
    }
  };
  return new Promise(poll);
};
